import React from 'react';
import './Policy.scss';
import InnerNav from '../components/InnerNav/InnerNav';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
        
      <div className="container">
        <h1>Privacy Policy</h1>
        <p>Welcome to Divya Jyotisa. We value your privacy and are committed to protecting your personal information. This Privacy Policy outlines the types of information we collect, how we use it, and your rights regarding your data when you use our website, <a href="https://asthaddestiny.com" target="_blank" rel="noopener noreferrer">https://asthaddestiny.com</a></p>

        <h2>1. Information We Collect</h2>
        <ul>
          <li><strong>Personal Information:</strong> When you contact us, book consultations, or subscribe to our newsletter, we may collect personal information such as your name, email address, phone number, birth details, and any other information you voluntarily provide.</li>
          <li><strong>Usage Data:</strong> We automatically collect certain information about your interaction with our Website, including your IP address, browser type, pages visited, and time spent on the site.</li>
          <li><strong>Cookies and Tracking Technologies:</strong> We use cookies and similar tracking technologies to enhance your experience, analyze site usage, and improve our services.</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <ul>
          <li><strong>Providing Services:</strong> To offer personalized astrological consultations and other services you request.</li>
          <li><strong>Communication:</strong> To respond to your inquiries and send updates or promotional materials.</li>
          <li><strong>Improvement and Analysis:</strong> To improve our Website’s functionality and service quality.</li>
          <li><strong>Legal Compliance:</strong> To comply with legal obligations and protect user rights and safety.</li>
        </ul>

        <h2>3. Sharing Your Information</h2>
        <ul>
          <li><strong>Service Providers:</strong> We may share information with third-party providers like payment processors, email services, or IT support.</li>
          <li><strong>Legal Obligations:</strong> We may disclose information if required by law or legal processes.</li>
        </ul>

        <h2>4. Data Security</h2>
        <p>We implement appropriate technical and organizational measures to protect your personal information. However, no method of transmission or storage is 100% secure.</p>

        <h2>5. Your Rights</h2>
        <ul>
          <li><strong>Access:</strong> Request a copy of your personal information.</li>
          <li><strong>Correction:</strong> Request correction of any inaccuracies.</li>
          <li><strong>Deletion:</strong> Request deletion of your personal data (subject to legal exceptions).</li>
          <li><strong>Objection:</strong> Object to certain types of processing.</li>
        </ul>
        <p>To exercise your rights, please contact us at [Your Contact Information].</p>

        <h2>6. Children’s Privacy</h2>
        <p>Our services are not directed to individuals under 18. We do not knowingly collect personal data from children under 18. If found, we will delete the data promptly.</p>

        <h2>7. Changes to This Privacy Policy</h2>
        <p>We may update this policy from time to time. Updates will be posted on this page with the new “Last Updated” date.</p>

        <h2>8. Contact Us</h2>
        <p>If you have any questions or concerns, please contact us at:</p>
        <p>
          <strong>Divya Jyotisa</strong><br />
          [destinyastha@gmail.com]<br />
          [+91 93824 81286]
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
